import { useMemo, useRef } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import {
  determineLoadingState, determineErrorState, useDataSourceOpts
} from '../common/utils/ContextUtils';
import { ENDPOINTS } from '../core/Constants';

export const useFetchChallengesInfo = ({ challengeType = undefined, skip = false } = {}) => {
  const challengesDataRef = useRef({});
  const opts = useDataSourceOpts({ skip }).opts;
  const challengesOpts = {
    ...opts,
    variables: {
      ...opts.variables, // 'sweepstakes', etc.
      challengeType,
    }
  };

  const challengesResponse = useDataModel(ENDPOINTS.CHALLENGES_INFO, challengesOpts);
  challengesDataRef.current = challengesResponse?.data && challengesResponse?.data[ENDPOINTS.CHALLENGES_INFO];

  const challengesData = challengesDataRef.current;
  const isLoadingChallenges = determineLoadingState(challengesResponse);
  const hasErrorChallenges = determineErrorState(challengesResponse);
  const refreshChallengeData = () => challengesResponse.refetch();

  return useMemo(() => ({
    isLoadingChallenges,
    hasErrorChallenges,
    challengesData,
    refreshChallengeData
  }), [challengesData, hasErrorChallenges, isLoadingChallenges]);
};

export const useFetchChallengesAccept = () => {

  return useMemo(() => ({

  }), []);
};
